<app-capture-history-item-title>
  <span class="estimated-value-header">
    {{ title }}
  </span>
</app-capture-history-item-title>

<app-capture-history-item-body>
  Set as <strong>{{ estimatedValue | currency: 'USD': 'symbol': '1.0-0' }}</strong>

  @if (methodDescription) {
    <div>
      <strong>Method:</strong> {{ methodDescription }}
    </div>
  }
</app-capture-history-item-body>
